import { render, staticRenderFns } from "./nomination-completed-tab.vue?vue&type=template&id=6b5e98da&scoped=true&"
import script from "./nomination-completed-tab.vue?vue&type=script&lang=js&"
export * from "./nomination-completed-tab.vue?vue&type=script&lang=js&"
import style0 from "./nomination-completed-tab.vue?vue&type=style&index=0&id=6b5e98da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5e98da",
  null
  
)

export default component.exports